import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CheckIcon, XIcon } from 'lucide-react';
export function Credibility() {
  return <SectionWrapper className="bg-white py-20" constrained={false} data-id="element-46">
      <div className="max-w-5xl mx-auto px-6" data-id="element-47">
        <div className="mb-16 text-center max-w-3xl mx-auto" data-id="element-48">
          <h2 className="font-sans text-2xl md:text-3xl font-bold text-ink mb-8" data-id="element-49">
            Este protocolo está basado en:
          </h2>
          <ul className="space-y-4 font-sans text-lg text-ink-mid inline-block text-left font-medium" data-id="element-50">
            <li className="flex items-center gap-3" data-id="element-51">
              <div className="w-2 h-2 rounded-full bg-coral shrink-0" data-id="element-52" />
              investigación en neurología del desarrollo infantil
            </li>
            <li className="flex items-center gap-3" data-id="element-53">
              <div className="w-2 h-2 rounded-full bg-coral shrink-0" data-id="element-54" />
              principios de regulación emocional y co-regulación
            </li>
            <li className="flex items-center gap-3" data-id="element-55">
              <div className="w-2 h-2 rounded-full bg-coral shrink-0" data-id="element-56" />
              técnicas de intervención conductual validadas
            </li>
            <li className="flex items-center gap-3" data-id="element-57">
              <div className="w-2 h-2 rounded-full bg-coral shrink-0" data-id="element-58" />
              la experiencia real de familias que dejaron de improvisar
            </li>
          </ul>
        </div>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-59">
          <div className="bg-cream-dark p-8 rounded-xl border border-hairline shadow-soft" data-id="element-60">
            <h3 className="font-sans text-2xl font-bold text-ink mb-6 flex items-center gap-3" data-id="element-61">
              <XIcon className="text-red-500 w-6 h-6" data-id="element-62" />
              No promete:
            </h3>
            <ul className="space-y-4 font-sans text-ink-mid font-medium" data-id="element-63">
              <li className="flex items-start gap-3" data-id="element-64">
                <span className="text-red-500 mt-1 shrink-0" data-id="element-65">❌</span>
                que tu hijo nunca volverá a tener una crisis
              </li>
              <li className="flex items-start gap-3" data-id="element-66">
                <span className="text-red-500 mt-1 shrink-0" data-id="element-67">❌</span>
                que esto reemplaza la orientación de un especialista si hay una
                necesidad específica
              </li>
              <li className="flex items-start gap-3" data-id="element-68">
                <span className="text-red-500 mt-1 shrink-0" data-id="element-69">❌</span>
                que funciona igual para todos los niños en todos los contextos
              </li>
            </ul>
          </div>

          <div className="bg-sage-light p-8 rounded-xl border border-sage/20 shadow-soft" data-id="element-70">
            <h3 className="font-sans text-2xl font-bold text-ink mb-6 flex items-center gap-3" data-id="element-71">
              <CheckIcon className="text-sage w-6 h-6" data-id="element-72" />
              Sí promete:
            </h3>
            <ul className="space-y-4 font-sans text-ink-mid font-medium" data-id="element-73">
              <li className="flex items-start gap-3" data-id="element-74">
                <span className="text-sage mt-1 shrink-0" data-id="element-75">✅</span>
                darte una herramienta real y accionable para el momento exacto
                en que todo explota
              </li>
              <li className="flex items-start gap-3" data-id="element-76">
                <span className="text-sage mt-1 shrink-0" data-id="element-77">✅</span>
                que en 90 minutos de lectura ya tienes el protocolo completo en
                la cabeza
              </li>
              <li className="flex items-start gap-3" data-id="element-78">
                <span className="text-sage mt-1 shrink-0" data-id="element-79">✅</span>
                que la próxima vez no vas a empezar desde cero
              </li>
            </ul>
          </div>
        </div>
      </div>
    </SectionWrapper>;
}